import { useProductDetailsTracking } from "@/mixins/tracking/product-details";
import { prixRemiseTotalProps, usePrixRemiseTotal } from "@/components/organisms/mixins/prix-remise-total.mixin";


export const productCategoryItemProps = () => ({
  cartContext: {
    type: String,
    required: false
  },
  index: {
    type: Number,
    required: false
  },
  showRecettes: {
    type: Boolean,
    required: false,
    default: false
  },
  showSubstitution: {
    type: Boolean,
    required: false,
    default: false
  },
  typePanier: {
    type: String,
    required: false,
    default: null
  },
  ...prixRemiseTotalProps()
})

export const productCategoryItemEmits = () => ([
  "setQuantity",
  "indexPoidsChanged",
  "plageSelected",
  "switchAccord"
])


export const useProductCategoryItem = (props, context) => {
  const { trackProductPage } = useProductDetailsTracking();
  const { prixTotalRemise } = usePrixRemiseTotal(props);
  const quantite = computed(() => {
    if (typeof props.article.quantite === "number") {
      return props.article.quantite;
    }
    return 1;
  })
  const prixTotal = computed(() => {
    return quantite.value * prix.value;
  })
  const isPft = computed(() => {
    return parseInt(props.article.pft) === 1 && !!props.article.pft_conf;
  })
  const isBuffet = computed(() => {
    return !!props.article.qte_pas
  })
  const poids = computed(() => {
    if (isPft.value) {
      return props.article.pft_conf.PLAGE[props.article.indexPoids].LIB_POIDS;
    }
    return null;
  })
  const prix = computed(() => {
    let prix = props.article.prix;
    if (isPft.value) {
      prix = props.article.pft_conf.PLAGE[props.article.indexPoids].PRIX;
    }
    return parseFloat(prix);
  })
  const isPanierLdd = computed(() => {
    return props.typePanier === 'ldd';
  })
  const isCarteKdo = computed(() => {
    return props.article.type === 'CKDO';
  })

  const setQuantity = (quantity) => {
    context.emit("setQuantity", quantity);
  }
  const plageSelected = ({index, type }) => {
    if(!isBuffet.value) {
      context.emit("indexPoidsChanged", index);
    }
    context.emit("plageSelected", { index, type });
  }
  const navigateToProductSheet = () => {
    trackProductPage({
      type: trackingCodes.PRODUCTCLICK,
      products: [{ id: props.article.id, attributes: { ...props.article } }],
      index: props.index + 1,
      actionField: props.cartContext
    });
  }
  const switchAccord = () => {
    context.emit("switchAccord", props.article);
  }

  return {
    prixTotalRemise,
    quantite,
    prixTotal,
    isPft,
    poids,
    prix,
    isPanierLdd,
    isCarteKdo,
    setQuantity,
    plageSelected,
    navigateToProductSheet,
    switchAccord,
    isBuffet
  }
}
